import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import AdminLayout from '../layout/AdminLayout.vue'
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import SmsSendingDashboardView from '../views/SmsSendingDashboardView.vue'
import MessageListView from '../views/MessageListView.vue'
import MessageDetailView from '../views/MessageDetailView.vue'
import SmsRecordQueryView from '../views/SmsRecordQueryView.vue'
import VoiceStrategyView from '../views/VoiceStrategyView.vue'
import ProviderView from '../views/ProviderView.vue'
import SmsConfigurationView from '../views/SmsConfigurationView.vue'
import CallbackExceptionsView from '../views/CallbackExceptionsView.vue'
import UatTestSendView from '../views/UatTestSendView.vue'
import OperationsView from '../views/OperationsView.vue'
import PushOperationsView from '../views/PushOperationsView.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { public: true }
    },
    {
      path: '/',
      component: AdminLayout,
      redirect: () => defaultLandingRoute(),
      children: [
        { path: 'dashboard', name: 'dashboard', component: DashboardView, meta: { title: '运行概览' } },
        { path: 'sms-dashboard', name: 'sms-dashboard', component: SmsSendingDashboardView, meta: { title: '短信发送看板' } },
        { path: 'push', name: 'push', component: PushOperationsView, meta: { title: 'Push 运营中心' } },
        { path: 'messages', name: 'messages', component: MessageListView, meta: { title: '发送记录' } },
        { path: 'messages/:messageId', name: 'message-detail', component: MessageDetailView, meta: { title: '发送详情' } },
        { path: 'sms-record-query', name: 'sms-record-query', component: SmsRecordQueryView, meta: { title: 'SMS Record Query', roles: ['SMS_RECORD_QUERY', 'ADMIN'] } },
        { path: 'voice-strategies', name: 'voice-strategies', component: VoiceStrategyView, meta: { title: '语音策略' } },
        { path: 'providers', name: 'providers', component: ProviderView, meta: { title: '供应商状态' } },
        { path: 'sms-config', redirect: { name: 'sms-config-templates' } },
        { path: 'sms-config/channels', name: 'sms-config-providers', component: SmsConfigurationView, meta: { title: '短信配置中心 / 短信通道', smsSection: 'providers' } },
        { path: 'sms-config/senders', name: 'sms-config-senders', component: SmsConfigurationView, meta: { title: '短信配置中心 / Sender ID', smsSection: 'senders' } },
        { path: 'sms-config/templates', name: 'sms-config-templates', component: SmsConfigurationView, meta: { title: '短信配置中心 / 短信模板', smsSection: 'templates' } },
        { path: 'sms-config/routes', name: 'sms-config-routes', component: SmsConfigurationView, meta: { title: '短信配置中心 / 发送路由', smsSection: 'bindings' } },
        { path: 'sms-config/legacy-template-channels', name: 'sms-config-legacy-bindings', component: SmsConfigurationView, meta: { title: '短信配置中心 / 旧版模板通道配置', smsSection: 'legacyBindings' } },
        { path: 'callback-exceptions', name: 'callback-exceptions', component: CallbackExceptionsView, meta: { title: '回调异常' } },
        { path: 'uat-test-send', name: 'uat-test-send', component: UatTestSendView, meta: { title: 'UAT 测试发送' } },
        { path: 'operations', name: 'operations', component: OperationsView, meta: { title: '运维中心', roles: ['OPS', 'ADMIN'] } }
      ]
    },
    { path: '*', redirect: '/dashboard' }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    next()
    return
  }
  if (!store.state.token) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }
  const requiredRoles = to.meta.roles || []
  const roles = (store.state.user && store.state.user.roles) || []
  const standardRoles = ['VIEWER', 'OPERATOR', 'OPS', 'ADMIN']
  if (to.name !== 'sms-record-query' && !roles.some(role => standardRoles.includes(role))) {
    next({ name: 'sms-record-query' })
    return
  }
  if (requiredRoles.length && !requiredRoles.some(role => roles.includes(role))) {
    next({ name: 'dashboard' })
    return
  }
  next()
})

export default router

function defaultLandingRoute () {
  const roles = (store.state.user && store.state.user.roles) || []
  return roles.includes('SMS_RECORD_QUERY') && !roles.some(role => ['VIEWER', 'OPERATOR', 'OPS', 'ADMIN'].includes(role))
    ? '/sms-record-query'
    : '/dashboard'
}
